// This file is automatically generated. Do not edit manually.

import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ProductChangeRequestView } from "src/api/generated/erp/db/types/tables/productChangeRequestView";
import { AppUser } from "src/api/generated/postgres/db/types/role_management/tables/appUser";
import { ProductChangeCategory } from "src/api/generated/erp/db/types/tables/productChangeCategory";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProductChangeRequestQueryApi {
	export async function getProductChangeRequestsGridData(args: {
		categoryId?: number | null | undefined;
		responsiblePersonId?: number | null | undefined;
		showCancelled?: boolean;
		showShelved?: boolean;
		searchQuery: string;
		onlyNotConnectedToChange?: boolean;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ProductChangeRequestQueryApi_ProductChangeRequestsGridData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/query/getProductChangeRequestsGridData",
			method: "POST",
			data: {
				categoryId: args.categoryId,
				responsiblePersonId: args.responsiblePersonId,
				showCancelled: args.showCancelled,
				showShelved: args.showShelved,
				searchQuery: args.searchQuery,
				onlyNotConnectedToChange: args.onlyNotConnectedToChange,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ProductChangeRequestQueryApi_ProductChangeRequestsGridData;
	}

	export async function getMyBoard(args: {
		showShelved: boolean;
		showCancelled: boolean;
	}): Promise<Array<ProductChangeRequestView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/query/getMyBoard",
			method: "POST",
			data: {
				showShelved: args.showShelved,
				showCancelled: args.showCancelled,
			},
		});
		return response as Array<ProductChangeRequestView>;
	}

	export async function getResponsiblePersonOptions(args: {
		currentSelection: number | null | undefined;
		searchQuery: string;
	}): Promise<Array<AppUser>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/query/getResponsiblePersonOptions",
			method: "POST",
			data: {
				currentSelection: args.currentSelection,
				searchQuery: args.searchQuery,
			},
		});
		return response as Array<AppUser>;
	}
}

export interface ProductChangeRequestQueryApi_ProductChangeRequestsGridData {
	categoryOptions: Array<ProductChangeCategory>;
	requests: ServerSideDataModelResult<ProductChangeRequestView>;
}
